var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eno-header"},[_c('div',{staticClass:"header-logo"},[_c('img',{attrs:{"src":_vm.config.logo,"alt":""}})]),(!_vm.isMobile)?_c('div',{staticClass:"header-menu"},[_c('enoMenu')],1):_c('div',{staticClass:"header-right"},[_c('H5_MENU'),_c('div',{staticClass:"header-info"},[_c('enoInfo')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }